<template>
  <div class="max-w-[90vw] mx-auto pb-10">
    <div class="w-full flex justify-end align-center">
      <v-container class="onest-font">
        <a
          @click.prevent="voltarParaDashboard"
          style="color: inherit; cursor: pointer; text-decoration: none"
          class="d-flex align-center d-inline-flex"
        >
          <v-icon size="20" class="mr-1">mdi-arrow-u-left-bottom</v-icon>
          <span style="text-decoration: underline">voltar</span>
        </a>
        <h1 class="font-bold mt-2 text-5xl">Resultados da Validação</h1>
        <div class="text-lg mt-2 flex flex-col text-gray-600">
          Selecione um roteiro e, em seguida, uma funcionalidade para visualizar
          os resultados dos formulários preenchidos pelos usuários.
        </div>
      </v-container>
    </div>

    <v-container>
      <div class="bg-white rounded-lg px-6 py-4 h-full elevation-1">
        <div v-if="loading" class="text-center py-12 text-gray-500 font-medium">
          <v-progress-circular
            indeterminate
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <p>Carregando roteiros...</p>
        </div>

        <div
          v-else-if="roteiros.length === 0"
          class="text-center py-12 text-gray-500 border border-dashed border-gray-300 rounded-lg"
        >
          <v-icon
            size="64"
            icon="mdi-emoticon-sad-outline"
            class="mb-4 text-gray-400"
          ></v-icon>
          <h3 class="text-xl font-bold mb-2">Nenhum resultado encontrado</h3>
          <p>
            Nenhum formulário foi vinculado ou preenchido para esta validação
            ainda.
          </p>
        </div>

        <v-expansion-panels
          v-else
          variant="accordion"
          class="border rounded-lg"
        >
          <v-expansion-panel
            v-for="roteiro in roteiros"
            :key="roteiro.id_roteiro"
            class="mb-1"
          >
            <v-expansion-panel-title class="font-bold text-lg">
              {{ roteiro.ator }}
              <v-chip
                class="ml-4 font-weight-medium"
                size="small"
                style="background-color: #e0e7ff; color: #5568ac"
              >
                {{ roteiro.funcionalidades.length }} Funcionalidade(s)
              </v-chip>
            </v-expansion-panel-title>
            <v-expansion-panel-text class="pt-2">
              <div
                v-if="roteiro.funcionalidades.length === 0"
                class="text-gray-500 italic py-2"
              >
                Nenhuma funcionalidade associada.
              </div>
              <v-list v-else class="bg-transparent pa-0">
                <v-list-item
                  v-for="funcionalidade in roteiro.funcionalidades"
                  :key="funcionalidade.id_formulario_escopo"
                  @click="
                    acessarResultados(funcionalidade.id_formulario_escopo)
                  "
                  class="mb-2 transition-colors border rounded-lg bg-gray-50 hover:bg-gray-100 cursor-pointer"
                  elevation="0"
                >
                  <div
                    class="d-flex align-center py-3 w-100 justify-space-between"
                  >
                    <div class="d-flex align-center">
                      <v-icon
                        icon="mdi-application-brackets"
                        class="text-blue-600 mr-3"
                      ></v-icon>
                      <span class="font-medium text-gray-800">
                        {{ funcionalidade.nome_funcionalidade }}
                      </span>
                    </div>
                    <v-icon class="text-gray-400">mdi-chevron-right</v-icon>
                  </div>
                </v-list-item>
              </v-list>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-container>
    <SnackBar ref="snackbar" />
  </div>
</template>

<script>
/**
 * @module ListaResultadosRoteiros
 * @desc Tela que exibe os roteiros e suas funcionalidades, permitindo acessar os resultados da validação de cada uma.
 */
import axios from 'axios';

import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

export default {
  name: 'ListaResultadosRoteiros',
  components: {
    SnackBar,
  },
  /**
   * Dados do componente.
   * @returns {Object}
   */
  data() {
    return {
      idProjeto: null,
      roteiros: [],
      loading: true,
    };
  },
  created() {
    this.idProjeto = this.$route.params.idProjeto;
    this.carregarRoteiros();
  },
  methods: {
    /**
     * Busca no backend a lista de roteiros com suas funcionalidades vinculadas a formulários.
     */
    async carregarRoteiros() {
      this.loading = true;
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(
          `${apiUrl}/api/v1/validacoes/projetos/${this.idProjeto}/roteiros-resultados`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.roteiros = response.data;
      } catch (error) {
        console.error('Erro ao carregar roteiros:', error);
        this.$refs.snackbar.showErrorSnackbar(
          'Erro',
          'Não foi possível carregar os resultados da validação deste projeto.',
        );
      } finally {
        this.loading = false;
      }
    },
    /**
     * Navega para a tela de detalhes da funcionalidade.
     * @param {number} idFormularioEscopo ID de vínculo do formulário com a funcionalidade.
     */
    acessarResultados(idFormularioEscopo) {
      this.$router.push({
        path: `/projects/${this.idProjeto}/resultados-funcionalidade/${idFormularioEscopo}`,
      });
    },
    /**
     * Retorna ao dashboard de validação do projeto.
     */
    voltarParaDashboard() {
      this.$router.push({
        path: `/project-validation/${this.idProjeto}`,
      });
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
